import { render, staticRenderFns } from "./XMLDescription.vue?vue&type=template&id=775999ad&"
import script from "./XMLDescription.vue?vue&type=script&lang=js&"
export * from "./XMLDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports